/**
 * @generated SignedSource<<f93a43cd889ecf7b9d7f8f2adc7e44ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LibraryHooksUseLeaveChannel_viewer$data = {
  readonly autoPublishRecordingSettings: {
    readonly enabled: boolean;
    readonly externalRecordingsChannel: {
      readonly id: string;
    } | null;
    readonly id: string;
    readonly internalRecordingsChannel: {
      readonly id: string;
    } | null;
  } | null;
  readonly " $fragmentType": "LibraryHooksUseLeaveChannel_viewer";
};
export type LibraryHooksUseLeaveChannel_viewer$key = {
  readonly " $data"?: LibraryHooksUseLeaveChannel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"LibraryHooksUseLeaveChannel_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LibraryHooksUseLeaveChannel_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserRecordingAutoPublishSettings",
      "kind": "LinkedField",
      "name": "autoPublishRecordingSettings",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Channel",
          "kind": "LinkedField",
          "name": "externalRecordingsChannel",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Channel",
          "kind": "LinkedField",
          "name": "internalRecordingsChannel",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "858122fcba60e926e97109d6345b19df";

export default node;
